import React from 'react';
import { useTranslation } from 'react-i18next';
import { Image, ImageBackground, StyleSheet, Text, View } from 'react-native';

import { FirstCup, SecondCup, ThirdCup, TotalLights } from '../../../../assets';
import { useSafeViewport } from '../../../../utils/hooks/useSafeViewport';

type RankCardProps = {
	backgroundImage: any;
	badge: any;
	gold: number;
	silver: number;
	bronze: number;
	total: number;
	color: string;
	cardWidth?: number;
};

const RankCardMobile = ({
	backgroundImage,
	badge,
	gold,
	silver,
	bronze,
	total,
	color,
	cardWidth,
}: RankCardProps) => {
	const { t } = useTranslation();
	const { width } = useSafeViewport();

	const isVerySmall = width < 420;
	const badgeSize = isVerySmall ? 74 : 92;
	const cupSize = isVerySmall ? 34 : 52;
	const countSize = isVerySmall ? 13 : 15;
	const totalFontSize = isVerySmall ? 12 : 14;
	const lightWidth = isVerySmall ? 42 : 52;

	const resolvedWidth = cardWidth ?? width * 0.8;

	return (
		<ImageBackground
			source={backgroundImage}
			style={[styles.card, { width: resolvedWidth }]}
			resizeMode='stretch'
			imageStyle={styles.cardBg}
		>
			<View style={styles.contentRow}>
				<Image
					source={badge}
					style={[styles.badgeImage, { width: badgeSize, height: badgeSize }]}
					resizeMode='contain'
				/>

				<View style={styles.trophyItem}>
					<Image
						source={FirstCup}
						style={[styles.trophyIcon, { width: cupSize, height: cupSize }]}
						resizeMode='contain'
					/>
					<Text style={[styles.trophyCount, { fontSize: countSize }]}>{gold}</Text>
				</View>

				<View style={styles.trophyItem}>
					<Image
						source={SecondCup}
						style={[styles.trophyIcon, { width: cupSize, height: cupSize }]}
						resizeMode='contain'
					/>
					<Text style={[styles.trophyCount, { fontSize: countSize }]}>{silver}</Text>
				</View>

				<View style={styles.trophyItem}>
					<Image
						source={ThirdCup}
						style={[styles.trophyIcon, { width: cupSize, height: cupSize }]}
						resizeMode='contain'
					/>
					<Text style={[styles.trophyCount, { fontSize: countSize }]}>{bronze}</Text>
				</View>

				<View style={styles.totalSection}>
					<Image
						source={TotalLights}
						style={[styles.totalLights, { width: lightWidth }]}
						resizeMode='stretch'
					/>
					<Text style={[styles.totalLabel, { fontSize: totalFontSize, color }]}>
						{t('T_SITE_TOURNAMENT_TOTAL')}
					</Text>
					<Image
						source={TotalLights}
						style={[styles.totalLights, { width: lightWidth }]}
						resizeMode='stretch'
					/>
					<Text style={[styles.totalValue, { fontSize: totalFontSize + 2, color }]}>{total}</Text>
				</View>
			</View>
		</ImageBackground>
	);
};

const styles = StyleSheet.create({
	card: {
		width: '100%',
		minHeight: 110,
		paddingHorizontal: 18,
		paddingVertical: 6,
		justifyContent: 'center',
		alignItems: 'center',
	},
	cardBg: {
		borderRadius: 16,
	},
	contentRow: {
		width: '100%',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	badgeImage: {
		flexShrink: 1,
	},
	trophyItem: {
		flex: 1,
		alignItems: 'center',
		justifyContent: 'center',
		minWidth: 0,
	},
	trophyIcon: {},
	trophyCount: {
		color: '#fff',
		fontWeight: 'bold',
		marginTop: 2,
	},
	totalSection: {
		flex: 1,
		alignItems: 'center',
		justifyContent: 'center',
		minWidth: 0,
	},
	totalLights: {
		height: 3,
		marginVertical: 1,
	},
	totalLabel: {
		fontWeight: 'bold',
		textAlign: 'center',
		textShadowColor: '#000',
		textShadowOffset: { width: 1, height: 2 },
		textShadowRadius: 3,
		letterSpacing: 0.5,
		textTransform: 'uppercase',
	},
	totalValue: {
		fontWeight: 'bold',
		textAlign: 'center',
		textShadowColor: '#000',
		textShadowOffset: { width: 1, height: 2 },
		textShadowRadius: 3,
		marginTop: 1,
	},
});

export default RankCardMobile;
